/**
 * One-time coachmark shown the first time the AI Tier switcher renders for a
 * user. Dismissible; sets `ui_meta.lineTierCoachmarkSeen` so it never returns.
 * See docs/pricing/line-tier-integration-plan.md §7h.
 *
 * Persistence is local-only in this scaffold — replace with a Firestore write
 * to `users/{uid}/ui_meta` in a follow-up so the flag survives device swaps.
 */

import { useEffect, useState } from 'react'
import { Button } from '../Common/Button'

const STORAGE_KEY = 'timelining_line_tier_coachmark_seen'

const readSeen = (): boolean => {
  if (typeof window === 'undefined') return true
  return window.localStorage.getItem(STORAGE_KEY) === '1'
}

const markSeen = () => {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(STORAGE_KEY, '1')
}

export const AiTierCoachmark = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (readSeen()) return
    // Wait a beat so the switcher paints before the coachmark points at it.
    const timer = window.setTimeout(() => setVisible(true), 350)
    return () => window.clearTimeout(timer)
  }, [])

  if (!visible) return null

  const dismiss = () => {
    markSeen()
    setVisible(false)
  }

  return (
    <div className="aiTierCoachmark" role="status" aria-live="polite">
      <strong>New: choose Line Pro or Line Max for higher-quality drafts.</strong>
      <span>Line is your default.</span>
      <Button variant="secondary" size="sm" onClick={dismiss} aria-label="Dismiss coachmark">Got it</Button>
    </div>
  )
}
